module.exports = __webpack_public_path__ + "img/icon-lzc-book.e77574ce.png";